// extracted by mini-css-extract-plugin
module.exports = {"profile":"profile_profile__3u2in","topSide":"profile_topSide__2H5lo","title":"profile_title__37EZj"};